// extracted by css-extract-rspack-plugin
module.exports =  {"userJobsTableWorkspaceSwitcher":"JobsTab__userJobsTableWorkspaceSwitcher___z0mRk","userJobsTable":"JobsTab__userJobsTable___eOAdM"};